
import React, {Component} from 'react';
import Iframe from 'react-iframe'
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'
import FontAwsome from 'react-fontawesome'
import './IframePrint.css';

var MobileDetect = require('mobile-detect')
class IframeModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {url:'',show:false}
    this.onHideFunc = ()=>{}
  }

  loadUrl(url,onHide){
    // console.log(url,window.navigator.userAgent)

    //let isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&(navigator.vendor.toLowerCase().indexOf("google") > -1));
    let md = new MobileDetect(window.navigator.userAgent);
    if(md.is('iOS') || md.is("AndroidOS") || this.props.modal ){

      this.setState({show:true,url:url})      

    }else{  
      window.open(url, '_blank');
    }
    
    //alert('isChrome:'+navigator.userAgent ); 
    this.onHideFunc = onHide
    
  }
  

  onHide(){
    this.setState({show:false})
    if(this.onHideFunc!==undefined){
      this.onHideFunc()
    }
    if (this.props.onUpImgHide!==undefined) {
      if (this.props.returnId!==undefined) {
        let {url} = this.state
        let url_string = url
        let url_new = new URL(url_string)
        let id = url_new.searchParams.get(this.props.param)
        this.props.onUpImgHide(id)
      } else {
        this.props.onUpImgHide()
      }  
    }
  }

  modalPrintDoc() {
    window.print() 
  }

  onConfirmClick() {
    this.props.onConfirmClick((result)=>{
      this.setState({show:false})
    })
  }

  renderFooter() {
    return(
              <Modal.Footer>
                {this.props.renderCustomFooter()}
                <ButtonToolbar className='pull-right'>
                    <Button onClick={this.onHide.bind(this)} className='btn btn-lg btn-default'><FontAwsome name='close'/>&nbsp;{'ไม่ยอมรับ'}</Button>
                    <Button onClick={this.onConfirmClick.bind(this)} className='btn btn-lg btn-primary'><FontAwsome name='thumbs-o-up'/>&nbsp;{'ยอมรับ'}</Button>
                </ButtonToolbar>
              </Modal.Footer>
    )
  }

  render(){
    let {title,style} = this.props
    let {show,url} = this.state
    return (
      <Modal className={style} show={show} onHide={this.onHide.bind(this)} enforceFocus={true} bsSize={'lg'} dialogClassName="fullwidth-dialog">
        <Modal.Header closeButton className="hide3">
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-print-report">

        <Iframe url={url}
        width="100%"
        height="100%"
        display="initial"
        position="relative"        
        allowFullScreen/>
        </Modal.Body>
        {this.props.footer?this.renderFooter():''}
    </Modal>              
    )
  }
}

IframeModal.defaultProps = {
  modal: false,
  title: '',
  footer: false,
  style: '',
  renderCustomFooter:()=>{}
}

export default IframeModal;





// WEBPACK FOOTER //
// ./src/component/element/IframeModal.js